{
  "app.name": "Tripy",
  "app.tagline": "The smart companion for travel in Iran",
  "common.ok": "OK",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.back": "Back",
  "common.next": "Next",
  "common.done": "Done",
  "common.retry": "Retry",
  "common.more": "More",
  "common.less": "Less",
  "common.seeAll": "See all",
  "common.share": "Share",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.loading": "Loading…",
  "common.search": "Search",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.today": "Today",
  "common.tomorrow": "Tomorrow",
  "common.yesterday": "Yesterday",
  "common.free": "Free",
  "common.perNight": "per night",
  "common.perPerson": "per person",
  "common.toman": "Toman",
  "common.day": "{n, plural, one {# day} other {# days}}",
  "common.night": "{n, plural, one {# night} other {# nights}}",
  "common.adult": "{n, plural, one {# adult} other {# adults}}",
  "common.child": "{n, plural, one {# child} other {# children}}",
  "common.reviewCount": "{n, plural, =0 {No reviews} one {# review} other {# reviews}}",
  "common.rating": "Rating",
  "common.new": "New",
  "common.offline": "You are offline; data may be stale.",
  "common.updateAvailable": "A new version is ready",
  "common.update": "Update",
  "common.errorTitle": "Something went wrong",
  "common.errorBody": "Please try again. If it persists, let us know.",
  "common.notFound": "Nothing found",
  "common.dismiss": "Later",
  "nav.today": "Today",
  "nav.trips": "Trips",
  "nav.explore": "Explore",
  "nav.profile": "Profile",
  "nav.add": "Add",
  "nav.addTicket": "Add ticket",
  "nav.planTrip": "Plan a trip",
  "onboarding.slide1.title": "Track your tickets live",
  "onboarding.slide1.body": "See your flight, train or bus on the map; know about delays and gates before anyone else.",
  "onboarding.slide2.title": "We plan your trip for you",
  "onboarding.slide2.body": "Tell us your budget; we pick the hotel, the sights and the route for every day.",
  "onboarding.slide3.title": "Discover the city",
  "onboarding.slide3.body": "The best places, rated and reviewed by travelers.",
  "onboarding.start": "Get started",
  "onboarding.login": "Log in",
  "onboarding.skip": "Skip",
  "auth.phone.title": "Phone number",
  "auth.phone.subtitle": "We will text you a verification code",
  "auth.phone.placeholder": "0912 345 6789",
  "auth.phone.invalid": "Invalid phone number",
  "auth.phone.submit": "Send code",
  "auth.phone.terms": "By continuing you accept the <terms>Terms</terms> and <privacy>Privacy Policy</privacy>.",
  "auth.otp.title": "Verification code",
  "auth.otp.subtitle": "Enter the 6-digit code sent to {phone}",
  "auth.otp.resend": "Resend",
  "auth.otp.devHint": "Dev code (test environment) — tap to fill",
  "auth.otp.resendIn": "Resend in {seconds}s",
  "auth.otp.editPhone": "Edit number",
  "auth.otp.wrong": "Wrong code",
  "auth.otp.expired": "Code expired; request a new one",
  "auth.otp.locked": "Too many attempts; try again later",
  "auth.rateLimited": "Please wait and try again ({seconds}s)",
  "auth.name.title": "What is your name?",
  "auth.name.placeholder": "Full name",
  "auth.logout": "Log out",
  "auth.logoutConfirm": "Log out of your account?",
  "today.greeting.morning": "Good morning{name}",
  "today.greeting.afternoon": "Good afternoon{name}",
  "today.greeting.evening": "Good evening{name}",
  "today.greeting.night": "Good night{name}",
  "today.nextSegment": "Next journey",
  "today.untilDeparture": "until departure",
  "today.untilArrival": "until arrival",
  "today.todayPlan": "Today’s plan",
  "today.upcomingTrips": "Upcoming trips",
  "today.empty.title": "No trips yet",
  "today.empty.body": "Add a ticket to track it live, or let us plan your trip.",
  "today.quick.addTicket": "Add ticket",
  "today.quick.plan": "Plan a trip",
  "status.scheduled": "Scheduled",
  "status.on_time": "On time",
  "status.delayed": "Delayed",
  "status.boarding": "Boarding",
  "status.departed": "Departed",
  "status.en_route": "En route",
  "status.arriving": "Arriving",
  "status.arrived": "Arrived",
  "status.cancelled": "Cancelled",
  "status.diverted": "Diverted",
  "status.unknown": "Unknown",
  "status.live": "Live",
  "status.estimated": "Estimated",
  "mode.flight": "Flight",
  "mode.train": "Train",
  "mode.bus": "Bus",
  "tracking.gate": "Gate",
  "tracking.terminal": "Terminal",
  "tracking.seat": "Seat",
  "tracking.platform": "Platform",
  "tracking.wagon": "Coach",
  "tracking.bay": "Bay",
  "tracking.belt": "Baggage belt",
  "tracking.pnr": "Booking ref",
  "tracking.scheduled": "Scheduled",
  "tracking.actual": "Actual",
  "tracking.estimated": "Estimated",
  "tracking.departure": "Departure",
  "tracking.arrival": "Arrival",
  "tracking.delayMinutes": "{n} min delay",
  "tracking.timeline": "Timeline",
  "tracking.delayHistory": "Delay history",
  "tracking.details": "Details",
  "tracking.follow": "Follow on map",
  "tracking.liveLost": "Live connection lost",
  "tracking.lastUpdate": "Last update {time}",
  "tracking.noLive": "Live data unavailable",
  "tracking.cancelledBanner": "This service is cancelled",
  "tracking.findAlternative": "Find an alternative",
  "tracking.addToCalendar": "Add to calendar",
  "tracking.removeTicket": "Remove ticket",
  "tracking.rateTrip": "Rate this trip",
  "tracking.step.checkin": "Check-in",
  "tracking.step.boarding": "Boarding",
  "tracking.step.departed": "Departed",
  "tracking.step.enRoute": "En route",
  "tracking.step.arrived": "Arrived",
  "tracking.progress": "{percent} of the way",
  "addTicket.title": "Add ticket",
  "addTicket.chooseMode": "Choose the mode",
  "addTicket.pasteSms": "Paste the ticket SMS or booking code",
  "addTicket.byNumber": "Flight/train number",
  "addTicket.bySearch": "Search schedule",
  "addTicket.number": "Number",
  "addTicket.numberHint.flight": "e.g. IR452",
  "addTicket.numberHint.train": "e.g. 112",
  "addTicket.numberHint.bus": "Company and service",
  "addTicket.date": "Date",
  "addTicket.from": "From",
  "addTicket.to": "To",
  "addTicket.search": "Search",
  "addTicket.noResults": "Not found; add it by number",
  "addTicket.confirm": "Confirm ticket",
  "addTicket.optional": "Optional",
  "addTicket.passenger": "Passenger name",
  "addTicket.addToTrip": "Add to trip",
  "addTicket.newTrip": "New trip",
  "addTicket.add": "Add",
  "addTicket.duplicate": "This ticket is already added",
  "addTicket.added": "Ticket added",
  "addTicket.viewTrip": "View trip",
  "trips.title": "Trips",
  "trips.upcoming": "Upcoming",
  "trips.past": "Past",
  "trips.empty.title": "No trips yet",
  "trips.empty.body": "Add a ticket or plan a new trip.",
  "trips.tab.overview": "Overview",
  "trips.tab.tickets": "Tickets",
  "trips.tab.itinerary": "Itinerary",
  "trips.tab.map": "Map",
  "trips.tab.budget": "Budget",
  "trips.deleteConfirm": "Delete this trip?",
  "trips.archived": "Archived",
  "trips.hotel": "Hotel",
  "trips.dayN": "Day {n}",
  "trips.regenerate": "Regenerate",
  "trips.regenerateDay": "Regenerate this day",
  "trips.shareTrip": "Share trip",
  "trips.status.upcoming": "Upcoming",
  "trips.status.active": "Active",
  "trips.status.done": "Done",
  "planner.title": "Plan a trip",
  "planner.step.destination": "Destination",
  "planner.step.dates": "Dates",
  "planner.step.travelers": "Travelers",
  "planner.step.budget": "Budget",
  "planner.step.style": "Style",
  "planner.step.review": "Review",
  "planner.destination.title": "Where to?",
  "planner.destination.search": "City name…",
  "planner.destination.popular": "Popular cities",
  "planner.dates.title": "When?",
  "planner.dates.fromTickets": "From tickets: {range}",
  "planner.dates.useTickets": "Use my tickets",
  "planner.travelers.title": "Who is going?",
  "planner.travelers.adults": "Adults",
  "planner.travelers.children": "Children",
  "planner.travelers.solo": "Solo",
  "planner.travelers.couple": "Couple",
  "planner.travelers.family": "Family",
  "planner.travelers.friends": "Friends",
  "planner.budget.title": "Budget",
  "planner.budget.have": "I have a budget",
  "planner.budget.estimate": "Estimate for me",
  "planner.budget.includeTickets": "Include tickets?",
  "planner.budget.total": "Total budget",
  "planner.tier.economy": "Economy",
  "planner.tier.mid": "Mid-range",
  "planner.tier.premium": "Premium",
  "planner.style.title": "Your style",
  "planner.pace.relaxed": "Relaxed",
  "planner.pace.balanced": "Balanced",
  "planner.pace.packed": "Packed",
  "planner.interests.title": "Interests",
  "planner.interest.history": "History",
  "planner.interest.gardens": "Gardens & nature",
  "planner.interest.food": "Food",
  "planner.interest.shopping": "Shopping",
  "planner.interest.religious": "Religious",
  "planner.interest.museum": "Museums",
  "planner.interest.art": "Art",
  "planner.interest.nightlife": "Nightlife",
  "planner.interest.family": "Family-friendly",
  "planner.interest.literature": "Literature",
  "planner.hotel.minStars": "Min stars",
  "planner.hotel.nearCenter": "Near the center",
  "planner.hotel.style.any": "Any",
  "planner.hotel.style.traditional": "Traditional",
  "planner.hotel.style.modern": "Modern",
  "planner.hotel.style.boutique": "Boutique",
  "planner.review.title": "Everything right?",
  "planner.generate": "Build it",
  "planner.generating.hotel": "Finding a hotel…",
  "planner.generating.places": "Picking the sights…",
  "planner.generating.routes": "Computing routes…",
  "planner.generating.budget": "Adding up the budget…",
  "planner.result.title": "Your trip plan is ready",
  "planner.result.underBudget": "{amount} under budget",
  "planner.result.overBudget": "{amount} over budget",
  "planner.result.changeHotel": "Change hotel",
  "planner.result.alternatives": "Alternatives",
  "planner.result.save": "Save trip",
  "planner.result.regenerate": "Regenerate",
  "planner.item.swap": "Swap",
  "planner.item.remove": "Remove",
  "planner.item.lock": "Lock",
  "planner.item.unlock": "Unlock",
  "planner.item.locked": "Locked",
  "planner.item.details": "Place details",
  "planner.item.navigate": "Navigate",
  "planner.item.addPlace": "Add a place",
  "planner.budgetInfeasible": "No plan fits this budget; you need at least about {amount}.",
  "planner.explain.highly_rated": "Highly rated",
  "planner.explain.iconic": "Iconic",
  "planner.explain.near_previous": "Near previous stop",
  "planner.explain.near_hotel": "Near hotel",
  "planner.explain.budget_friendly": "Budget-friendly",
  "planner.explain.open_late": "Open late",
  "planner.explain.sunset_spot": "Sunset spot",
  "planner.explain.local_favorite": "Local favorite",
  "planner.explain.day_trip": "Day trip",
  "planner.explain.locked_by_you": "Locked by you",
  "planner.explain.hot_weather_indoor": "Indoor for the heat",
  "planner.explain.best_morning": "Best in the morning",
  "itinerary.title": "Day plan",
  "itinerary.now": "Now",
  "itinerary.walk": "Walk {duration}",
  "itinerary.taxi": "Taxi {duration}",
  "itinerary.car": "Car {duration}",
  "itinerary.checkin": "Hotel check-in",
  "itinerary.checkout": "Hotel check-out",
  "itinerary.meal.lunch": "Lunch",
  "itinerary.meal.dinner": "Dinner",
  "itinerary.meal.breakfast": "Breakfast",
  "itinerary.meal.cafe": "Café",
  "itinerary.free": "Free time",
  "itinerary.navigateWith": "Navigate with…",
  "itinerary.app.neshan": "Neshan",
  "itinerary.app.balad": "Balad",
  "itinerary.app.waze": "Waze",
  "itinerary.app.google": "Google Maps",
  "itinerary.cost": "Cost",
  "explore.title": "Explore",
  "explore.popularCities": "Popular cities",
  "explore.nearYou": "Near you",
  "explore.weekly": "Pick of the week",
  "explore.topRated": "Top rated",
  "explore.attractions": "Sights",
  "explore.hotels": "Hotels",
  "explore.food": "Food & cafés",
  "explore.planTo": "Plan a trip to {city}",
  "explore.sort.rating": "Rating",
  "explore.sort.popularity": "Popularity",
  "explore.sort.distance": "Distance",
  "explore.openNow": "Open now",
  "explore.closedNow": "Closed now",
  "explore.hours": "Hours",
  "explore.address": "Address",
  "explore.website": "Website",
  "explore.instagram": "Instagram",
  "explore.wikipedia": "About this place on Wikipedia",
  "explore.entryFee": "Entry fee",
  "explore.avgMeal": "Average cost",
  "explore.addToTrip": "Add to trip",
  "explore.amenities": "Amenities",
  "explore.roomTypes": "Rooms",
  "explore.starsOfficial": "{n}-star",
  "explore.chooseForTrip": "Choose for trip",
  "explore.book": "Book",
  "explore.category.attraction": "Sight",
  "explore.category.restaurant": "Restaurant",
  "explore.category.cafe": "Café",
  "explore.category.hotel": "Hotel",
  "explore.category.shopping": "Shopping",
  "explore.category.nature": "Nature",
  "explore.category.religious": "Religious",
  "explore.category.museum": "Museum",
  "explore.category.park": "Park",
  "explore.category.other": "Other",
  "place.menu": "Menu",
  "place.report": "Report wrong info",
  "place.report.title": "What's wrong?",
  "place.report.placeholder": "e.g. the opening hours changed, the map location is off…",
  "place.report.send": "Send report",
  "place.report.thanks": "Thanks — we'll look into it.",
  "source.snappfood": "SnappFood",
  "source.foursquare": "Foursquare",
  "service.snapp": "Ride with Snapp",
  "service.snappfood": "Order on SnappFood",
  "service.alibaba": "Buy tickets on Alibaba",
  "service.buyTicket": "Buy tickets",
  "itinerary.snapp": "Snapp {duration}",
  "service.snappAction": "Ride with",
  "service.snappfoodAction": "Order food from",
  "hotel.checkin": "Check-in from {time}",
  "hotel.checkout": "Check-out by {time}",
  "amenity.wifi": "Wi-Fi",
  "amenity.breakfast": "Breakfast",
  "amenity.pool": "Pool",
  "amenity.spa": "Spa",
  "amenity.parking": "Parking",
  "amenity.restaurant": "Restaurant",
  "amenity.gym": "Gym",
  "amenity.garden": "Garden",
  "amenity.kitchen": "Kitchen",
  "amenity.shuttle": "Airport shuttle",
  "amenity.view": "Scenic view",
  "amenity.beach": "Beach",
  "reviews.title": "Reviews",
  "reviews.write": "Write a review",
  "reviews.yourRating": "Your rating",
  "reviews.titlePlaceholder": "Title (optional)",
  "reviews.bodyPlaceholder": "Share your experience (at least 20 characters)",
  "reviews.addPhotos": "Add photos",
  "reviews.submit": "Submit",
  "reviews.submitted": "Review submitted",
  "reviews.pending": "Pending approval",
  "reviews.helpful": "Helpful",
  "reviews.helpfulCount": "{n, plural, one {# person found this helpful} other {# people found this helpful}}",
  "reviews.report": "Report",
  "reviews.sort.recent": "Most recent",
  "reviews.sort.helpful": "Most helpful",
  "reviews.visited": "Visited {date}",
  "reviews.empty": "No reviews yet; be the first.",
  "reviews.needAuth": "Log in to write a review",
  "budget.title": "Budget",
  "budget.total": "Total",
  "budget.of": "of {amount}",
  "budget.remaining": "Remaining",
  "budget.over": "Over budget",
  "budget.cat.tickets": "Tickets",
  "budget.cat.hotel": "Stay",
  "budget.cat.food": "Food",
  "budget.cat.attractions": "Sights & fees",
  "budget.cat.transport": "Transport",
  "budget.cat.misc": "Other",
  "budget.adjust": "Adjust budget",
  "budget.perDay": "Per day",
  "budget.perPerson": "Per person",
  "budget.estimated": "Estimated",
  "budget.actual": "Actual",
  "search.placeholder": "City, place, hotel…",
  "search.recent": "Recent searches",
  "search.cities": "Cities",
  "search.places": "Places",
  "search.hotels": "Hotels",
  "search.myTrips": "My trips",
  "search.tickets": "Tickets",
  "profile.title": "Profile",
  "profile.stats.trips": "trips",
  "profile.stats.cities": "cities",
  "profile.stats.reviews": "reviews",
  "profile.appearance": "Appearance",
  "profile.theme": "Theme",
  "profile.theme.system": "System",
  "profile.theme.dark": "Dark",
  "profile.theme.light": "Light",
  "profile.glass": "Glass transparency",
  "profile.glassHint": "Turn off on low-end phones",
  "profile.language": "Language & calendar",
  "profile.locale": "Language",
  "profile.digits": "Persian digits",
  "profile.calendar": "Calendar",
  "profile.calendar.persian": "Jalali",
  "profile.calendar.gregory": "Gregorian",
  "profile.notifications": "Notifications",
  "profile.about": "About",
  "profile.terms": "Terms",
  "profile.privacy": "Privacy",
  "profile.version": "Version {version}",
  "profile.deleteAccount": "Delete account",
  "notifications.title": "Notifications",
  "notifications.markAll": "Mark all read",
  "notifications.empty": "No notifications",
  "notifications.enable.title": "Know about delays and gate changes",
  "notifications.enable.body": "Allow notifications so you hear it first.",
  "notifications.enable.cta": "Enable notifications",
  "notifications.pref.delay": "Delays",
  "notifications.pref.gate": "Gate/platform changes",
  "notifications.pref.boarding": "Boarding time",
  "notifications.pref.arrival": "Arrival",
  "notifications.pref.tripReminder": "Trip reminders",
  "notifications.pref.reviewReply": "Review replies",
  "notifications.pref.quietHours": "Quiet hours",
  "share.title": "Share trip",
  "share.includeTickets": "Include tickets?",
  "share.includeBudget": "Include budget?",
  "share.copyLink": "Copy link",
  "share.revoke": "Stop sharing",
  "share.public.cta": "Plan with Tripy",
  "pwa.install.title": "Add Tripy to your Home Screen",
  "pwa.install.body": "Opens faster and you get notifications.",
  "pwa.install.ios.step1": "Tap the Share button",
  "pwa.install.ios.step2": "Choose “Add to Home Screen”",
  "pwa.install.ios.step3": "Tap “Add”",
  "pwa.install.cta": "Install",
  "pwa.install.later": "Later",
  "transport.flight": "Flight",
  "transport.train": "Train",
  "transport.bus": "Bus",
  "transport.airline": "Airline",
  "transport.company": "Company",
  "tickets.title": "Tickets",
  "tickets.all": "All tickets",
  "tickets.upcoming": "Upcoming",
  "tickets.past": "Past",
  "tickets.empty.title": "No tickets yet",
  "tickets.empty.body": "Add a flight, train or bus ticket and follow it live on the map.",
  "tickets.noTripTickets": "No tickets attached to this trip.",
  "tickets.attachExisting": "Attach an existing ticket",
  "tickets.detach": "Detach from trip",
  "addTicket.step.mode": "Type",
  "addTicket.step.find": "Find",
  "addTicket.step.confirm": "Confirm",
  "addTicket.modeTitle": "What are you travelling with?",
  "addTicket.findTitle": "Find your {mode}",
  "addTicket.byNumberHint": "Enter the number printed on your ticket",
  "addTicket.route": "Route",
  "addTicket.pickStation": "Choose",
  "addTicket.origin": "Origin",
  "addTicket.destination": "Destination",
  "addTicket.results": "{n} results",
  "addTicket.noResultsBody": "Nothing scheduled for that day. Try another date or add it manually.",
  "addTicket.manual": "Add manually",
  "addTicket.depTime": "Departure time",
  "addTicket.arrTime": "Arrival time",
  "addTicket.seat": "Seat",
  "addTicket.coach": "Coach",
  "addTicket.pnr": "Booking ref (PNR)",
  "addTicket.price": "Price (Toman)",
  "addTicket.role.outbound": "Outbound",
  "addTicket.role.return": "Return",
  "addTicket.role.other": "Other",
  "addTicket.noTrip": "No trip",
  "addTicket.trackNow": "Track now",
  "addTicket.demoTitle": "Try a live demo",
  "addTicket.demoBody": "Create a 3-minute simulated flight departing now to see live tracking.",
  "addTicket.demoStart": "Start demo flight",
  "addTicket.pastServiceHint": "This service already departed.",
  "tracking.title": "Live tracking",
  "tracking.map": "Map",
  "tracking.status": "Status",
  "tracking.eta": "ETA",
  "tracking.etd": "ETD",
  "tracking.duration": "Duration",
  "tracking.remaining": "Remaining",
  "tracking.distance": "Distance",
  "tracking.speed": "Speed",
  "tracking.altitude": "Altitude",
  "tracking.aircraft": "Aircraft",
  "tracking.vehicle": "Vehicle",
  "tracking.number": "Number",
  "tracking.date": "Date",
  "tracking.onTime": "On time",
  "tracking.delayed": "Delayed {n} min",
  "tracking.early": "{n} min early",
  "tracking.was": "was {time}",
  "tracking.gateNotAssigned": "Not yet",
  "tracking.liveDot": "Live",
  "tracking.reconnecting": "Reconnecting…",
  "tracking.offlinePolling": "Updating every minute",
  "tracking.step.scheduled": "Scheduled",
  "tracking.step.arriving": "Arriving",
  "tracking.event.status_changed": "Status: {to}",
  "tracking.event.delay_changed": "Delay {to} min",
  "tracking.event.eta_changed": "New ETA {to}",
  "tracking.event.gate_changed": "Gate {to}",
  "tracking.event.platform_changed": "Platform {to}",
  "tracking.event.position_first": "Position received",
  "tracking.noEvents": "No changes yet",
  "tracking.removeConfirm": "Remove this ticket?",
  "tracking.removed": "Ticket removed",
  "tracking.attachToTrip": "Attach to a trip",
  "tracking.attached": "Attached to trip",
  "tracking.openTrip": "Open trip",
  "tracking.passenger": "Passenger",
  "tracking.notify": "Notify me about changes",
  "tracking.shareText": "Follow my {kind} {number} live on Tripy",
  "tracking.centerOnVehicle": "Center on vehicle",
  "tracking.fitRoute": "Whole route",
  "today.nextTicket": "Next ticket",
  "today.trackLive": "Track live",
  "today.otherTickets": "Other tickets",
  "today.seeAllTickets": "All tickets",
  "today.arrivedRecently": "Arrived",
  "reviews.sort.rating_high": "Highest rated",
  "reviews.sort.rating_low": "Lowest rated",
  "reviews.withPhotos": "With photos",
  "reviews.all": "All",
  "reviews.stars": "{n} stars",
  "reviews.count": "{n, plural, one {# review} other {# reviews}}",
  "reviews.edit": "Edit review",
  "reviews.delete": "Delete review",
  "reviews.deleted": "Review deleted",
  "reviews.updated": "Review updated",
  "reviews.yours": "Your review",
  "reviews.reply": "Reply",
  "reviews.replies": "{n, plural, one {# reply} other {# replies}}",
  "reviews.replyPlaceholder": "Write a reply…",
  "reviews.send": "Send",
  "reviews.showReplies": "Show all replies",
  "reviews.reportTitle": "Report this review",
  "reviews.reportReason.spam": "Spam or ads",
  "reviews.reportReason.offensive": "Offensive",
  "reviews.reportReason.irrelevant": "Not about this place",
  "reviews.reportReason.fake": "Fake / misleading",
  "reviews.reportReason.other": "Other",
  "reviews.reported": "Thanks — we’ll review it",
  "reviews.visitedOn": "When did you visit?",
  "reviews.draftSaved": "Draft saved",
  "reviews.uploading": "Uploading…",
  "reviews.photoTooLarge": "Photo is too large (max 10 MB)",
  "reviews.photoFailed": "Upload failed; try again",
  "reviews.tooShort": "Write a bit more (at least 20 characters)",
  "reviews.mine.title": "My reviews",
  "reviews.mine.empty": "You haven’t reviewed anywhere yet.",
  "reviews.helpfulShort": "{n}",
  "notifications.empty.title": "Nothing here yet",
  "notifications.empty.body": "Delays, gate changes and trip reminders show up here.",
  "notifications.markAllRead": "Mark all read",
  "notifications.settings": "Notification settings",
  "notifications.push.title": "Get live alerts",
  "notifications.push.body": "We’ll ping you for boarding, delays, gate changes and reminders — only what matters.",
  "notifications.push.enable": "Turn on alerts",
  "notifications.push.later": "Maybe later",
  "notifications.push.enabled": "Alerts are on",
  "notifications.push.denied": "Notifications are blocked in your browser settings.",
  "notifications.push.unsupported": "This browser doesn’t support push notifications.",
  "notifications.push.iosInstallFirst": "On iPhone, add Tripy to your Home Screen first to receive alerts.",
  "notifications.push.test": "Send a test notification",
  "notifications.push.devices": "This device",
  "notifications.pref.departures": "Boarding & departures",
  "notifications.pref.delays": "Delays & ETA changes",
  "notifications.pref.gates": "Gate & platform changes",
  "notifications.pref.planner": "Trip reminders",
  "notifications.pref.social": "Replies to my reviews",
  "notifications.pref.general": "News & tips",
  "notifications.pref.quiet": "Quiet hours",
  "notifications.pref.quietBody": "Only cancellations break through.",
  "notifications.pref.from": "From",
  "notifications.pref.to": "To",
  "pwa.install.button": "Install",
  "pwa.install.ios.title": "Add to Home Screen",
  "pwa.update.title": "A new version is ready",
  "pwa.update.button": "Update",
  "pwa.offline.cached": "You’re offline — showing saved data",
  "profile.myReviews": "My reviews",
  "profile.installApp": "Install the app",
  "common.to": "to",
  "today.myTrips": "My Trips",
  "today.searchAdd": "Search to add a ticket",
  "today.section.live": "In transit",
  "today.section.upcoming": "Upcoming",
  "today.section.trips": "Trips",
  "today.section.recent": "Recent",
  "today.newTrip": "New trip",
  "today.planCta": "Plan a trip",
  "today.planCtaBody": "Tell us the city and dates — we build the hotel, day-by-day plan and budget.",
  "today.nextStep": "Next step",
  "today.idle.cta": "Start journey",
  "today.idle.country": "Iran",
  "today.mapStyle": "Map style",
  "common.tripCount": "{n} trips",
  "tracking.untilDeparture": "TO DEPART",
  "tracking.untilArrival": "TO ARRIVE",
  "tracking.minutes": "MINUTES",
  "tracking.chip.inAir": "IN AIR",
  "tracking.chip.enRoute": "EN ROUTE",
  "tracking.chip.arrived": "ARRIVED",
  "tracking.chip.cancelled": "CANCELED",
  "tracking.chip.boarding": "BOARDING",
  "tracking.chip.arriving": "ARRIVING",
  "tracking.departsIn": "Departs in {t}",
  "tracking.arrivesIn": "Arrives in {t}",
  "tracking.landsIn": "Lands in {t}",
  "tracking.departsOnTime": "Departs On Time",
  "tracking.departsLate": "Departs {n}m late",
  "tracking.arrivesOnTime": "Arrives On Time",
  "tracking.arrivesLate": "Arrives {n}m late",
  "tracking.onTimeShort": "On Time",
  "tracking.lateShort": "{n}m late",
  "tracking.departedAt": "Departed • {t}",
  "tracking.arrivedAt": "Arrived • {t}",
  "tracking.band.onTime": "Running on time",
  "tracking.band.onTimeSub": "Scheduled departure at {t}",
  "tracking.band.delayed": "{n}m delay",
  "tracking.band.delayedSub": "New departure time {t}",
  "tracking.band.boarding": "Boarding",
  "tracking.band.boardingSub": "Departs in {t}",
  "tracking.band.gateIn": "Gate departure in {t}",
  "tracking.band.enRoute": "En route",
  "tracking.band.enRouteSub": "Arrives in {t} • {pct}% of the way",
  "tracking.band.arriving": "Arriving",
  "tracking.band.arrivingSub": "Arrives in {t}",
  "tracking.band.arrived": "Arrived",
  "tracking.band.arrivedSub": "{t} • {delta}",
  "tracking.band.cancelled": "Canceled",
  "tracking.band.cancelledSub": "This service is not operating",
  "tracking.band.unknown": "Status unknown",
  "tracking.originBlock": "Origin",
  "tracking.destBlock": "Destination",
  "tracking.forecast": "Forecast",
  "tracking.forecastSub": "Performance over the last 60 days",
  "tracking.forecast.early": "Early",
  "tracking.forecast.ontime": "On time",
  "tracking.forecast.late15": "15m late",
  "tracking.forecast.late30": "30m late",
  "tracking.forecast.late45": "45m+ late",
  "tracking.forecast.cancelled": "Canceled",
  "tracking.forecast.onTimeRate": "On time",
  "tracking.forecast.avgLate": "Average of late",
  "tracking.forecast.noData": "No history for this route yet",
  "tracking.goodToKnow": "Good to know",
  "tracking.wagonShort": "Car",
  "passport.title": "Travel Passport",
  "passport.subtitle": "Your travel stats with Tripy",
  "passport.allTime": "ALL-TIME",
  "passport.flights": "flights",
  "passport.trains": "trains",
  "passport.buses": "buses",
  "passport.trips": "trips",
  "passport.cities": "cities",
  "passport.hours": "hours traveling",
  "passport.per": "TICKETS PER",
  "passport.perYear": "Year",
  "passport.perMonth": "Month",
  "passport.perWeekday": "Weekday",
  "passport.distance": "Distance traveled",
  "passport.avgDistance": "Average per ticket: {d}",
  "passport.aroundIran": "Around Iran's borders",
  "passport.tehranMashhad": "Tehran to Mashhad",
  "passport.toMoon": "To the Moon",
  "passport.empty": "No tickets yet. Add your first ticket to start your passport.",
  "passport.longest": "Longest journey",
  "passport.topRoute": "Most traveled route",
  "passport.onTimeRate": "On-time rate",
  "profile.passport": "Travel Passport",
  "trips.new": "New trip",
  "trips.nights": "{n} nights",
  "trips.daysCount": "{n} days",
  "insights.title": "AI insights",
  "insights.subtitle": "A smart summary of history, vibe and what people feel",
  "insights.sentiment": "What people feel",
  "insights.positives": "Positives",
  "insights.negatives": "Negatives",
  "insights.source.curated": "From Tripy data",
  "insights.source.llm": "AI-generated",
  "insights.loading": "Summarising…",
  "insights.error": "No insights right now",
  "auth.rateLimitedMin": "Too many code requests — try again in about {minutes} min",
  "trips.warn.noHotels": "No hotel within this budget in our data — pick one yourself.",
  "trips.warn.hotelOverBudget": "The chosen hotel exceeds the lodging share of the budget.",
  "trips.warn.generic": "Part of the plan could not be completed.",
  "trips.warn.noRestaurant": "No restaurant suggestion for {slot} on day {days} — fill the gap yourself.",
  "trips.warn.slot.lunch": "lunch",
  "trips.warn.slot.dinner": "dinner",
  "trips.warn.slot.breakfast": "breakfast",
  "trips.warn.slot.cafe": "café",
  "common.listSep": ", ",
  "common.and": "and"
}
